import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import store from '../../store'
import { SET_GLOBAL_LOADING } from '../../store/mutation-types'
import seo from './seo'
import hashScroll from './hashScroll'

const dataLoad = {
  mixins: [ seo, hashScroll ],
  props: {
    type: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'page',
      'loading'
    ]),
    pageApiData: {
      get () {
        return this.page(this.lang, this.$route.meta.pageName, this.type)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    // set env to loading
    store.commit(SET_GLOBAL_LOADING, true)
    // extract language
    const lang = _.split(to.name, '-')[0] || 'it'
    // start loading
    await store.dispatch('loadPageData', { pageName: to.meta.pageName, lang, type: to.params.type })
    store.commit(SET_GLOBAL_LOADING, false)
    // we finished!
    next(vm => {
      if (to.hash) vm.$_scrollToHash(to.hash)
    })
  },
  methods: {
    ...mapActions([
      'loadPageData'
    ])
  }
}

export default dataLoad
